import { PayloadAction } from "@reduxjs/toolkit";

import { NavigationState } from "../../types";

export const setClientFuelEventsData = (
  state: NavigationState,
  action: PayloadAction<NavigationState["clientEvents"]["fuel"]["data"]>
) => {
  state.clientEvents.fuel.data = action.payload;
};

export const setClientFuelEventLoadingStatus = (
  state: NavigationState,
  action: PayloadAction<
    NavigationState["clientEvents"]["fuel"]["loadingStatus"]
  >
) => {
  state.clientEvents.fuel.loadingStatus = action.payload;
};
